<nz-empty
  class="empty-container"
  nzNotFoundImage="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
  [nzNotFoundContent]="contentTpl">
  <ng-template #contentTpl>
      <span class="pt-8 font-medium text-center">
        {{ 'empty.data_empty' | translate }}
      </span>
  </ng-template>
</nz-empty>
